import React from "react";


import {
    Col
} from "react-bootstrap";


import "./index.scss";


type CardTitleComponentProps = {
    cardTitle: string;
    cardTitleType?: 'default' | 'special';
};


export const CardTitleComponent:React.FC<CardTitleComponentProps> = ({
    cardTitle, cardTitleType = 'default'
}) => {

    if (!cardTitle) {
        return null;
    }

    return (
        <Col xs={12} className={`card-title-component ${cardTitleType}-card-title`}>
            <span>{cardTitle}</span>
        </Col>
    );

};


export default CardTitleComponent;
